export const modalType = {
  None: 'none',
  AddressLog: 'addressLog',
  AddressInfo: 'addressInfo',
  CopyCostCenter: 'copyCostCenter',
  BankLog: 'bankLog',
  TeamInfo: 'teamInfo',
  AgentInfo: 'agentInfo',
  BrokerRates: 'brokerRates',
  BankAccount: 'bankAccount',
  Commission: 'commission',
  Revoke: 'revoke',
  DefaultAgent: 'defaultAgent',
  TeamHierarchy: 'teamHierarchy',
};

export const isModalTypeCorrect = value => {
  if (value === 'none') return false;
  return Object.values(modalType).includes(value);
};
